import * as log from 'loglevel';

/**
 * Returns the URL of the shop (without the path, without http(s)://), e.g.:
 *   - "www.hach.de"
 *   - "www.oppermann.de"
 */
function getShopUrl() {
  const url = window.location.origin;
  return url.substring(url.indexOf('://') + 3); // remove http(s)://
}

/*
 * Interface / Bridge how the embedding website can interact with the kartendesigner app
 * Defines a function to load a card as well as callbacks when the user puts the card
 * into the basket or on the wishlist.
 */
export default class CardLoader {
  constructor(store) {
    this.store = store;
  }

  /**
   * Loads a greeting card and opens the kartendesigner app
   * @param {Object} cardConfig - The card object, which defines sides, layers and themes
   * @param {Object} options - Additional options:
   *   - themeId: the theme ID to load (e.g. "505a1af7-1662-47f3-8e65-2ebd0a6c84b3")
   *   - themeHex: the hex code of the theme ID to load,
   *               used if themeId is not present (e.g. "#FF0000")
   */
  loadCard(cardConfig, options) {
    let card = cardConfig;
    if (typeof cardConfig === 'string') {
      try {
        card = JSON.parse(card);
      } catch (e) {
        log.error(e);
        return new Promise((resolve, reject) => reject());
      }
    }
    // load user uploads from local storage
    // TODO: Move to own function, with promise (clean up)
    const userUploadsAsString = window.localStorage.getItem('kartendesigner-user-images');
    if (userUploadsAsString) {
      try {
        const userUploads = JSON.parse(userUploadsAsString);
        userUploads.forEach((imageUrl) => {
          this.store.commit('ADD_USER_IMAGE', imageUrl);
        });
      } catch (e) { log.error('Could not load user uploads from local storage: ', userUploadsAsString); }
    }
    // check if card contains a shop URL, if not set it:
    if (!card.shopUrl) {
      card.shopUrl = getShopUrl();
    }
    if (options && options.mode) {
      if (options.mode === 'cart') {
        this.store.commit('SET_TEXTS', {
          cartButtonText: 'Speichern',
          cartButtonWithSleeveText: 'Speichern und Umschlag auswählen',
          wishlistButtonText: 'Auf die Merkliste',
          closeButtonText: 'Schließen',
        });
      } else if (options.mode === 'wishlist') {
        this.store.commit('SET_TEXTS', {
          cartButtonText: 'In den Einkaufswagen',
          cartButtonWithSleeveText: 'In den Einkaufswagen mit Umschlag',
          wishlistButtonText: 'Auf Merkliste speichern',
          closeButtonText: 'Schließen',
        });
      }
    }
    return this.store.dispatch('LOAD_CARD', {
      card,
      themeId: options && options.themeId ? options.themeId : null,
      paperId: options && options.paperId ? options.paperId : null,
    });
  }
}
